import { State, Action, StateContext, Selector } from '@ngxs/store';
import { WorkLocationService } from './service';
import { IWorkLocationState, IWorkLocation } from './types';
import { SetCurrentTab, SetFiltersBasedOnTab, SetSearchField } from './actions';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { IPagination } from '../../../../modules/authorization/store/types';

const defaults: IWorkLocationState = {
    isLoading: null,
    currentTab: null,
    searchField: '',
    generalWorkLocationsFilters: {
        page: 1,
        results: 100,
        sort: '',
        active: true
    },
    inactiveWorkLocationsFilters: {
        page: 1,
        results: 100,
        sort: '',
        active: false
    },
    generalWorkLocations: null,
    inactiveWorkLocations: null
};

@State<IWorkLocationState>({
    name: 'workLocation',
    defaults
})
@Injectable()
export class WorklocationState {

    @Selector()
    static isLoading(state: IWorkLocationState) {
        return state.isLoading;
    }

    @Selector()
    static currentTab(state: IWorkLocationState) {
        return state.currentTab;
    }

    @Selector()
    static searchField(state: IWorkLocationState) {
        return state.searchField;
    }

    @Selector()
    static generalWorkLocationsFilters(state: IWorkLocationState) {
        return state.generalWorkLocationsFilters;
    }

    @Selector()
    static inactiveWorkLocationsFilters(state: IWorkLocationState) {
        return state.inactiveWorkLocationsFilters;
    }

    @Selector()
    static generalWorkLocations(state: IWorkLocationState) {
        return state.generalWorkLocations;
    }

    @Selector()
    static inactiveWorkLocations(state: IWorkLocationState) {
        return state.inactiveWorkLocations;
    }

    constructor(private workLocationService: WorkLocationService) { }

    @Action(SetCurrentTab)
    SetCurrentTab(ctx: StateContext<IWorkLocationState>, action: SetCurrentTab) {
        const state = ctx.getState();
        ctx.patchState({ currentTab: action.tab || state.currentTab || 'GENERAL' });
        ctx.dispatch(new SetFiltersBasedOnTab({ page: 1, ...action.filters }));
    }

    @Action(SetSearchField)
    SetSearchField(ctx: StateContext<IWorkLocationState>, action: SetSearchField) {
        ctx.patchState({ searchField: action.value });
        ctx.dispatch(new SetFiltersBasedOnTab({ page: 1 }));
    }

    @Action(SetFiltersBasedOnTab)
    SetFiltersBasedOnTab(ctx: StateContext<IWorkLocationState>, action: SetFiltersBasedOnTab) {
        let state = ctx.getState();
        ctx.patchState({ isLoading: true });
        switch (state.currentTab) {
            case 'INACTIVE': 
                ctx.patchState({
                    inactiveWorkLocationsFilters: {
                        ...state.inactiveWorkLocationsFilters,
                        ...action.filters
                    }
                });
                state = ctx.getState();
                return this.workLocationService.fetchAll({ ...state.inactiveWorkLocationsFilters, search: state.searchField })
                    .pipe(tap((pagination: IPagination<IWorkLocation>) => ctx.patchState({ inactiveWorkLocations: pagination, isLoading: false })));  
            default:
                ctx.patchState({
                    generalWorkLocationsFilters: {
                        ...state.generalWorkLocationsFilters,
                        ...action.filters
                    }
                });
                state = ctx.getState();
                return this.workLocationService.fetchAll({ ...state.generalWorkLocationsFilters, search: state.searchField })
                    .pipe(tap((pagination: IPagination<IWorkLocation>) => ctx.patchState({ generalWorkLocations: pagination, isLoading: false })));
        }
    }

}
